import * as React from "react";
import { Button, required } from "react-admin";
import { Container, Grid, Paper } from "@material-ui/core";
import { Form } from "react-final-form";
import SearchIcon from "@material-ui/icons/Search";
import { useState } from "react";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import { Add } from "@material-ui/icons";
import { ReliabilityReportType } from "../../../Enums/ReliabilityReportType";
import ReliabilityManualRogueCreate from "../ManualCreate/ReliabilityManualRogueCreate";

const RogueFilter = ({ filterParams, setFilterParams }: any) => {
  const [createOpen, setCreateOpen] = useState<boolean>(false);

  const onSubmit = values => {
    setFilterParams(values);
  };
  const onCloseCreate = () => {
    setCreateOpen(false);
  };
  const onOpenCreate = e => {
    setCreateOpen(true);
  };

  return (
    <Container maxWidth="xl">
      <ReliabilityManualRogueCreate
        isOpen={createOpen}
        onClose={onCloseCreate}
        reportType={ReliabilityReportType.RogueCandidate}
      />
      <Form
        onSubmit={onSubmit}
        initialValues={filterParams}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Paper style={{ padding: 10 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <CustomDatetime
                    source="startDate"
                    fullWidth
                    variant="outlined"
                    label="Start Date"
                    validate={required()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <CustomDatetime
                    source="endDate"
                    fullWidth
                    variant="outlined"
                    label="End Date"
                    validate={required()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    label="Search"
                    size="large"
                    startIcon={<SearchIcon />}
                    style={{ marginTop: 6 }}
                  />
                  <Button
                    onClick={onOpenCreate}
                    variant="contained"
                    color="primary"
                    disabled={submitting}
                    label="Create"
                    size="large"
                    startIcon={<Add />}
                    style={{ marginTop: 6, marginLeft: 5 }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </form>
        )}
      />
    </Container>
  );
};

export default RogueFilter;
